// extracted by mini-css-extract-plugin
module.exports = {"back__button":"BackButton_back__button__1Imiz","back__button__icon":"BackButton_back__button__icon__1lfxj","back__button__text":"BackButton_back__button__text__qxHHa"};